import HoverCard from "@/common/components/HoverCard";
import { AllocatedAndConsumedDetails } from "../../types/companySummaryOfAllAllocatedAndConsumed.type";
import { InfoIcon } from "lucide-react";
import { formatDecimalUnit } from "@/common/utils/formatters";

interface CompanySummaryOfAllAllocatedAndConsumedHoverCardProps {
  summaryOfAllAllocatedAndConsumed?: AllocatedAndConsumedDetails
}

export default function CompanySummaryOfAllAllocatedAndConsumedHoverCard({
  summaryOfAllAllocatedAndConsumed,
}: CompanySummaryOfAllAllocatedAndConsumedHoverCardProps) {
  const summaryData = summaryOfAllAllocatedAndConsumed
  const categories = Object.entries(summaryData?.categories || {})
  const products = Object.entries(summaryData?.products || {})

  return (
    <HoverCard
      openDelay={250}
      closeDelay={0}
      trigger={
        <div className="flex min-w-8">
          <InfoIcon className='max-w-5' />
        </div>
      }
      className="bg-white-200 backdrop-blur-3xl z-[1000] border-0 p-4 rounded-md max-h-[300px] min-w-[250px] overflow-auto"
      triggerClassName='w-full'
      align="start"
      sideOffset={-2}
    >
      <div className="flex flex-col gap-4">
        {summaryData ? (
          <>
            <div className="flex flex-col gap-2">
              <p className="text-sm font-bold text-white-400 border-b border-white-400 pb-1">Categorias</p>
              {categories.map(([categoryId, category]) => {
                const firstUnit = products.find(
                  ([_, product]) => product.category_id === categoryId
                )?.[1].unit_for_quantity

                const formattedSumAllocated = formatDecimalUnit(category.sum_allocated, firstUnit)
                const formattedSumConsumed = formatDecimalUnit(category.sum_consumed, firstUnit)

                return (
                  <div key={categoryId} className="flex flex-col bg-white-5 p-2 rounded">
                    <p className="text-sm font-bold">{category.display_name}</p>
                    <div className="flex flex-col justify-between mt-1">
                      <p className="text-xs">Alocado: {formattedSumAllocated}</p>
                      <p className="text-xs text-yellow-400">Consumido: {formattedSumConsumed}</p>
                    </div>
                  </div>
                )
              })}
            </div>

            <div className="flex flex-col gap-2 mt-2">
              <p className="text-sm font-bold text-white-400 border-b border-white-400 pb-1">Produtos</p>
              {products.map(([productId, product]) => {
                const formattedSumAllocated = formatDecimalUnit(product.sum_allocated, product.unit_for_quantity)
                const formattedSumConsumed = formatDecimalUnit(product.sum_consumed, product.unit_for_quantity)

                return (
                  <div key={productId} className="flex flex-col bg-white-5 p-2 rounded">
                    <p className="text-sm font-bold">{product.display_name}</p>
                    <div className="flex flex-col justify-between mt-1">
                      <p className="text-xs">
                        Alocado: {formattedSumAllocated}
                      </p>
                      <p className="text-xs text-yellow-400">
                        Consumido: {formattedSumConsumed}
                      </p>
                    </div>
                  </div>
                )
              })}
            </div>
          </>
        ) : (
          <div className="p-4 text-center">
            <p className="text-xs text-white-400 italic">Esse empenho não possui resumo.</p>
          </div>
        )}
      </div>
    </HoverCard>
  )
}
